import api from '@motionelements/core/src/api/base-api-v2';

export const registerAffiliate = async () => api.request('post', '/v2/account/affiliate', {
  params: api.getLocaleParams(),
});

export const unregisterAffiliate = async () => api.request('delete', '/v2/account/affiliate', {
  params: api.getLocaleParams(),
});

